import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=31091c4e&scoped=true"
import script from "./OverviewPage.vue?vue&type=script&lang=js"
export * from "./OverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31091c4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31091c4e')) {
      api.createRecord('31091c4e', component.options)
    } else {
      api.reload('31091c4e', component.options)
    }
    module.hot.accept("./OverviewPage.vue?vue&type=template&id=31091c4e&scoped=true", function () {
      api.rerender('31091c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/dataops/pages/OverviewPage.vue"
export default component.exports